import { gql } from "@apollo/client";

export const SEARCH_PROJECT_IDS = gql`
  query searchProjectIds($organisationId: String!, $query: String!) {
    searchProjectIds(organisationId: $organisationId, query: $query)
  }
`;
